import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/styles/element_custom.scss'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@/assets/fonts/fonts.scss'
import Clipboard from 'v-clipboard'
import * as svgicon from 'vue-svgicon'

import { capitalize } from '@/services/filter'

import i18n from '@/lang'

import vueMoment from 'vue-moment'
import locale from 'moment/locale/fr'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(vueMoment, {
  locale
})
Vue.use(Clipboard)
Vue.use(svgicon)

Vue.filter('capitalize', capitalize)

router.beforeEach((to, from, next) => {
  // Request with token inside
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
  } else if (store.getters['auth/isLoggedIn']) {
    next()
  } else {
    store.dispatch('auth/logout')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js